import { observer } from 'mobx-react'
import React, { FC, PropsWithChildren } from 'react'

import { Button, FiltersButton, useToggle } from '@avantstay/backoffice-core'

import { FilterWidgetProps } from '@new/__global/components/Filters/_types'

import { UiStore } from '@stores/UiStore'

import * as S from './FiltersWidget.styles'

export const FiltersWidget: FC<PropsWithChildren<FilterWidgetProps>> = observer(
  ({
    children,
    countSelectedFilters = 0,
    isClearAllDisabled,
    onApplyFilters,
    onClearAllFilters,
    onClearOtherFilters,
  }) => {
    const [showFilters, toggleShowFilters, setShowFilters] = useToggle(false)

    const handleClearFilters = () => {
      toggleShowFilters()
      onClearOtherFilters?.()
    }

    const handleApplyFilters = () => {
      onApplyFilters?.()
      setShowFilters(false)
    }

    const handleClearAllFiltersWithCheck = () => {
      onClearAllFilters?.()
      onClearOtherFilters?.()
    }

    const renderMainView = () => (
      <S.MainContainer>
        <S.Header>
          <S.TitleRow>
            <S.ExitButton onClick={toggleShowFilters} />
            <S.Title>Apply Filters</S.Title>
          </S.TitleRow>
          <S.ActionsRow>
            <Button.Flat onClick={() => UiStore.toggleExpandAllFilterSideBarItems()}>
              {UiStore.shouldExpandAllFilterSidebarItems ? 'Collapse All' : 'Expand All'}
            </Button.Flat>

            {onClearAllFilters ? (
              <Button.Flat onClick={handleClearAllFiltersWithCheck} disabled={isClearAllDisabled}>
                Clear All
              </Button.Flat>
            ) : null}
          </S.ActionsRow>
        </S.Header>
        <S.ChildrenContainer>{children}</S.ChildrenContainer>

        <S.Footer>
          <Button.Secondary onClick={handleClearFilters}>Cancel</Button.Secondary>
          <Button.Primary onClick={handleApplyFilters}>Apply filters</Button.Primary>
        </S.Footer>
      </S.MainContainer>
    )

    return (
      <>
        <FiltersButton
          isActive={countSelectedFilters > 0}
          onClick={toggleShowFilters}
          activeFiltersLength={countSelectedFilters}
        />

        {showFilters ? renderMainView() : null}
      </>
    )
  },
)
